import React, { useState } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { useFirebase } from '../contexts/FirebaseContext';

const REQUEST_CATEGORIES = [
  'Payroll Providers',
  'POS Merchant Providers',
  'Default Payout Methods',
  'Roles'
];

export const ConfigurationRequestForm: React.FC = () => {
  const [category, setCategory] = useState(REQUEST_CATEGORIES[0]);
  const [description, setDescription] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'submitted'>('idle');
  const { user, tenantId } = useFirebase();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!tenantId || !user) return;
    setStatus('submitting');
    
    try {
      await addDoc(collection(db, 'support_requests'), {
        tenantId,
        userEmail: user.email,
        category,
        description,
        createdAt: serverTimestamp(),
      });
      setStatus('submitted');
      setDescription('');
    } catch (error) {
      console.error("Error submitting request:", error);
      setStatus('idle');
      alert("Failed to submit request.");
    }
  };

  if (status === 'submitted') {
    return <div className="p-4 bg-green-50 text-green-700 rounded">Request submitted successfully!</div>;
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <h3 className="text-lg font-bold">Request a Configuration Change</h3>
      <p className="text-sm text-gray-600">Please use this form to request changes to supported platform configurations.</p>
      
      <div>
        <label className="block text-sm font-medium mb-1">Category</label>
        <select 
          value={category} 
          onChange={(e) => setCategory(e.target.value)}
          className="w-full p-2 border rounded"
          required
        >
          {REQUEST_CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>

      <div>
        <label className="block text-sm font-medium mb-1">Details</label>
        <textarea 
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className="w-full p-2 border rounded"
          rows={4}
          required
          placeholder="Please describe the changes you need..."
        />
      </div>

      <button 
        type="submit"
        disabled={status === 'submitting'}
        className="bg-blue-600 text-white p-2 rounded disabled:opacity-50"
      >
        {status === 'submitting' ? 'Submitting...' : 'Submit Request'}
      </button>
    </form>
  );
};
